export default function ReloadButton() {
    return (
        <button
            className="mt-2.5 px-2 py-1 rounded-md bg-(--rs-selected-bg) text-white hover:bg-fluent-blue-600 transition-colors"
            onClick={() => window.location.reload()}
        >
            Reload
        </button>
    );
}
